import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "../lib/apiClient";
import { formatRelativeTime } from "../lib/formatRelativeTime";
import type { MessageThreadSummary } from "@shared/types";

/** Inbox — one row per accepted connection, modeled on EscalationsPage.tsx's load/list pattern. */
export function MessagesPage() {
  const navigate = useNavigate();
  const [threads, setThreads] = useState<MessageThreadSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ threads: MessageThreadSummary[] }>("/api/messages")
      .then((data) => setThreads(data.threads))
      .catch((err) => setError(err instanceof ApiError ? err.message : "Failed to load your messages."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="muted">Loading…</p>;

  return (
    <div className="content-col-wide">
      {error && <p className="error-text">{error}</p>}
      {threads.length === 0 ? (
        <div className="card">
          <p className="muted">No conversations yet — connect with someone on the Network page to start messaging.</p>
        </div>
      ) : (
        <div className="card">
          {threads.map((t) => (
            <button className="message-thread-row" key={t.otherUserId} onClick={() => navigate(`/messages/${t.otherUserId}`)}>
              <div className="message-thread-main">
                <span className="message-thread-name">{t.otherUserFullName ?? t.otherUserEmail}</span>
                <span className="message-thread-preview muted">{t.lastMessage ?? "No messages yet"}</span>
              </div>
              <div className="message-thread-meta">
                {t.lastMessageAt && <span className="muted">{formatRelativeTime(t.lastMessageAt)}</span>}
                {t.unreadCount > 0 && <span className="tab-badge">{t.unreadCount}</span>}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
